module.exports = __webpack_public_path__ + "img/green.d871e227.jpg";